<template>
  <div id="wrap" class="out">
    <div class="anli_detail_banner">
      <img src="https://www.kingdee.com/news-static/img/anli_detail/banner.png">

      <div class="text">
        <div class="w1000">
          <h2 class="fnt_18 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">通过与金蝶合作财务ERP项目，作为财务数字化管理的基础，帮助京东数科集团降本增效，实现核算规则集团统一化，集成化，并减少了账务层面繁琐的手工处理，提升财务数据的准确性。未来会在更多领域展开更为深入的合作。</h2>
          <div class="banner-text fnt_16 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">——财务流程总监 姜云鹏  京东数字科技集团</div>
        </div>
      </div>
    </div>
    <div class="anli_detail_tag">
      <div class="w1000">
        <div class="anli_tag_text">
          <div class="text">
            <div class="num_list">
              <div class="num_item">
                <div class="fnt_32">
                  <span>提升25%</span>
                </div>
                <div class="sub_text fnt_14">管理报表合并效率</div>
              </div>
              <div class="num_item">
                <div class="fnt_32">
                  <span>降低30%</span>
                </div>
                <div class="sub_text fnt_14">报表人力成本</div>
              </div>
              <div class="num_item">
                <div class="fnt_32">
                  <span>降低40%</span>
                </div>
                <div class="sub_text fnt_14">基础核算工作</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anli_detail_article">
      <div class="w1000">
        <h1>京东数科：业财协同推动集团精细化运营</h1>
        <div class="detail_article">
          <div class="anli_item">
            <div class="subtitle fnt_24">客户概述</div>
            <div class="summary fnt_16">
              <p>京东数字科技集团是一家致力于以AI驱动产业数字化的新型科技公司，创立于京东集团内部，于2013年10月开始独立运营。京东数科以AI、数据技术、物联网、区块链等时代前沿数字科技为基础，建立并发展起核心的数字化风险管理能力、用户 运营能力、产业理解能力和B2B2C模式的企业服务能力。</p>
              <p>截至目前，公司完成了在智能城市、数字农牧、金融科技、资管科技、数字营销、数字乡村、智能机器人等领域的布局，服务客户纵贯个人端、企业端、政府端。</p>
              <p>截至2019年6月，京东数科已累计服务涵盖4亿个人用户、800万线上线下小微企业、700多家各类金融机构、17000家创业创新公司、30余座城市的政府及其他公共服务机构。</p>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">业务挑战</div>
              <div class="summary fnt_16">
                <p>1. 财务核算系统与商城共用，从科目、报表的设计不适用金融行业，核算效率低，管理成本高;</p>
                <p>2. 国外系统的操作繁琐，经常需要导出线下处理，给财务人员带来大量重复、低效的工作量;</p>
                <p>3. 业务和核算的数据口径不规范、不统一，无法给管理层提供快捷、准确的分析数据;</p>
                <p>4. 费控系统存在体验不好、缺少管理信息等问题，亟待改善;</p>
                <p>5. 需要整合集成各系统;</p>
              <p>&nbsp;</p></div>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">解决方案</div>
              <div class="summary fnt_16"><p>总体信息化方案：按“总体规划、分步实施、自上而下、上下结合”的原则进行建设。</p>
                <center><img src="https://www.kingdee.com/dsfile-static/jeditor/4_1637116675488.png" alt="" width="800" height="399"></center>
                <p>1. 搭建独立的集团财务管控平台</p>
                <p>将原业务快速迁移到搭建的独立核算新平台，实现核心主数据</p>
                <p>集成、采购及费用的业务管控协同实时核算、为管理者快速提供</p>
                <p>科目体系到各类报表分析，并为后期全面预算管控，全面业财协同，法人及利润中心核算自动化等业务应用打下坚实基础。通过接口，去规范数据、协同业务，实现业财一体化。为高层提供全面决策支持，帮助集团的快速稳健发展。</p>
                <p>2. 建立金融集团管控体系</p>
                <p>集成人资、财务等主数据，将总部和控股分子公司纳入进来，实时生凭证;自动编报表;基于核算场景进行费用预提/冲销、内部往来清理。搭建集团管控的财务核算体系，不断实现在线化核算。</p>
                <p>3. 提供决策管理支持</p>
                <p>预算实际的数据分析、各法人公司的盈利预测、各金融产品的收入/成本分析，统计实际数来源于实际业务分摊后数据，提供准确的各业务线运营的分析数据。</p>
                <p>4. 加强行政采购、费用报销的内控</p>
                <p>打通相关业务系统，实现数据信息不落地，保障准确核算，实时核算。整合内采流程，从需求申请到资产入库、领用、核算，全部在线化。数据准确;报销集成发票云，采集发票信息、自动验验重。业财税一体化;报销自动发起付款;内采自动按付款计划发起付款申请;采集费用的管理信息。核算用发票，管控用管理信息;按规则自动扩展审批级次的审批流;异常单据/流程监控、预警。</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">项目价值</div>
              <div class="summary fnt_16"><p>管控集团化</p>
                <p>自有财务管控平台，集成主数据，承载业务及核算，为管理层提供及时、统一、规范的信息;实现了法定、模拟两种线上合并，高效的为管理层提供全面准确的经营数据;核算自动化，节省了核算工作成本，为管理层提供了实时、准确的信息。</p>
                <p>流程规范化</p>
                <p>完善税务的线上管理，使得税务筹划有坚实的基础，规避税务风险;</p>
                <p>通过独立集团核算平台，构建了满足金融集团的核算体系，规范了财务政策和制度。</p>
                <p>业财一体化</p>
                <p>通过搭建财务预算体系，提供预实分析，辅助了业务线的经营管理;</p>
                <p>优化行采、费用、库存转资等业务流程，加强了财务内控，使信息采集更完整。</p>
              <p>&nbsp;</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CircleBtn @back="back" />
  </div>
</template>

<script>
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'Successcase3',
  components: { CircleBtn },
  data() {
    return {
    }
  },
  mounted() {
    document.querySelector('#wrap').scrollIntoView(true)
  },

  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}
.out {
  padding-bottom: 50px;
}
.anli_detail_banner {
    position: relative;
    overflow: hidden;
}
.anli_detail_banner img {
    width: 100%;
}
@media only screen and (max-width: 1366px){
.anli_detail_banner .text {
    top: 50%;
}
}
.anli_detail_banner .text {
    position: absolute;
    width: 100%;
    position: absolute;
    top: 55%;
    left: 0;
    transform: translateY(-50%);
    color: #fff;
    text-align: left;
}
.w1000 {
    width: 1000px;
    margin: 0 auto;
    max-width: 94%;
}
.anli_detail_banner .text h2 {
    margin-bottom: 28px;
    width: 65%;
    line-height: 1.88em;
    padding: 0 25px;
}
.anli_detail_banner .text .banner-text {
    margin-bottom: 44px;
    line-height: 1.7em;
    padding: 0 25px;
}
.anli_detail_banner .text h2:before {
    content: "";
    display: block;
    width: 41px;
    height: 34px;
    background: url(../../../assets/yinhao.png);
    opacity: 0.3;
    margin-bottom: 8px;
}
.fnt_18 {
    font-size: 18px;
}
.anli_detail_tag {
  text-align: left;
}
.anli_detail_tag .anli_tag_text {
    padding: 25px;
    background: #fff;
    font-size: 0;
    box-shadow: 1px 1px 20px 5px rgb(0 132 246 / 20%);
    transform: translateY(-50%);
}
.anli_detail_tag .anli_tag_text .img {
    /* padding: 10px; */
    border: 1px solid #eeeeed;
    display: inline-block;
    vertical-align: middle;
}
.anli_detail_tag .anli_tag_text .text {
    display: inline-block;
    vertical-align: middle;
    width: calc(100% - 60px);
    margin-left: 30px;
    margin-right: 30px;
    color: #888888;
}
.anli_detail_tag .anli_tag_text .img img {
    width: 114px;
}
.anli_detail_tag .anli_tag_text .img .img_mobil {
    display: none;
}
.anli_detail_tag .anli_tag_text .title {
    margin-bottom: 8px;
}
.fnt_16 {
    font-size: 16px;
}
.anli_detail_tag .anli_tag_text .title span:first-child {
    font-weight: 600;
    color: #333333;
    margin-right: 20px;
}
.anli_detail_tag .anli_tag_text .text a {
    color: #888888;
}
@media only screen and (max-width: 1440px){
.fnt_24 {
    font-size: 20px;
}
}
.fnt_24 {
    font-size: 24px;
}
.num_list {
    font-size: 0;
    padding: 2.1% 0;
    text-align: center;
}
.num_item {
    display: inline-block;
    width: 33%;
    color: #888888;
    text-align: center;
    position: relative;
    vertical-align: top;
    padding: 0 10px;
}

.fnt_14 {
    font-size: 14px;
}
.num_item .fnt_32 {
    font-weight: 600;
    color: #0084f6;
}
@media only screen and (max-width: 1440px) {
.fnt_32 {
    font-size: 24px;
}
}
.anli_detail_article {
  text-align: left;
}
h2 {
  margin-bottom: 20px;
  font-size: 28px;
  line-height: 40px;
}
.subtitle {
    color: #2386ee;
    margin-bottom: 20px;
}
.fnt_24 {
    font-size: 24px;
}
.fnt_16 {
    font-size: 16px;
}
.summary p {
    margin-bottom: 1.5em;
    line-height: 2em;
    font-size: 15px;
}
h1 {
  font-size: 30px;
  text-align: center;
  margin-bottom: 10px;
}
.num_item:after {
    content: "";
    width: 1px;
    height: 80px;
    background: #e6e6e6;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.num_item:last-child:after{display: none;}
</style>>



// WEBPACK FOOTER //
// src/views/successcase/components/Jd.vue